export default __webpack_public_path__ + "static/media/camera-retro.1f0f432e.svg";